<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in decodedLinks">
        <span
          v-if="link.url === null"
          :key="key"
          class="mr-1 mb-1 px-4 py-3 text-sm leading-4 text-gray-400 border rounded"
        >
          {{ link.label }}
        </span>
        <inertia-link
          v-else
          :key="key + '-else'"
          class="mr-1 mb-1 px-4 py-3 text-sm leading-4 border rounded hover:bg-white focus:border-indigo-500 focus:text-indigo-500"
          :class="{ 'bg-white': link.active }"
          :href="link.url"
        >
          {{ link.label }}
        </inertia-link>
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue2'
export default {
    components: { 'inertia-link': Link },
    props: {
        links: Array,
    },
    computed: {
        decodedLinks() {
            return this.links.map(l => ({
                ...l,
                label: l.label.replace(/&laquo;/g, '«').replace(/&raquo;/g, '»'),
            }))
        },
    },
}
</script>
